
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hzUx3", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $2549fc1cd4ffe721$export$f23a75298e125425);
$parcel$export(module.exports, "default", () => $2549fc1cd4ffe721$export$2e2bcd8739ae039);
/* index-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $9CGHC = parcelRequire("9CGHC");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $dqc6Z = parcelRequire("dqc6Z");

var $6t09S = parcelRequire("6t09S");

var $fZbyz = parcelRequire("fZbyz");

var $gSEff = parcelRequire("gSEff");

var $lRvdJ = parcelRequire("lRvdJ");

var $16reJ = parcelRequire("16reJ");

var $gYTjK = parcelRequire("gYTjK");
const $2549fc1cd4ffe721$export$f23a75298e125425 = (isOpen = false)=>(0, $eJOHy.useState)(isOpen);
const $2549fc1cd4ffe721$var$CreatePullRequestDropdownInner = ({ createPullRequestTargets: createPullRequestTargets, renderDropdownTrigger: renderDropdownTrigger, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $2549fc1cd4ffe721$export$f23a75298e125425();
    const [filteredTargets, setFilteredTargets] = (0, $eJOHy.useState)(createPullRequestTargets ?? []);
    const wasOpen = (0, $6d9QY.usePreviousWithInitial)(isOpen);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        setFilteredTargets(createPullRequestTargets ?? []);
    }, [
        createPullRequestTargets
    ]);
    const filterTargetsBySearch = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'searchTerm' implicitly has an 'any' type.
    (searchTerm)=>{
        setFilteredTargets(createPullRequestTargets ? createPullRequestTargets.filter((target)=>{
            const targetDisplayName = (0, $gSEff.getTargetDisplayName)(target);
            return (0, $9CGHC.default)(targetDisplayName, searchTerm);
        }) : []);
    }, [
        createPullRequestTargets
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (wasOpen !== isOpen) {
            isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createPullRequestDropdown');
            !isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createPullRequestDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        wasOpen,
        isOpen,
        onOpenDropdown
    ]);
    const CreatePullRequestTargets = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2549fc1cd4ffe721$var$TargetsContainer, null, hasErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fZbyz.CreatePullRequestAuthenticationRow), {
            onClick: ()=>{
                onAuthErrorClick && onAuthErrorClick();
                setIsOpen(false);
            }
        }), filteredTargets.map((target, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSEff.CreatePullRequestTargetRow), {
                key: `${index}-${target.createPullRequestUrl}`,
                createPullRequestTarget: target
            }))), [
        filteredTargets,
        hasErrors,
        onAuthErrorClick,
        setIsOpen
    ]);
    const DropDownWithTargetsContent = (0, $eJOHy.useMemo)(()=>{
        let targetsContent;
        if (createPullRequestTargets && createPullRequestTargets.length > 0 && filteredTargets.length === 0) targetsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gYTjK.NoResultsFound), null);
        else if (createPullRequestTargets && createPullRequestTargets.length >= 0) targetsContent = CreatePullRequestTargets;
        else targetsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6t09S.DevSummaryCreatePullRequestPopupSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $2549fc1cd4ffe721$var$dropDownWithTargetsContentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2549fc1cd4ffe721$var$SearchFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            onChange: (value)=>filterTargetsBySearch(value),
            onBlur: ()=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'input blurred', 'createPullRequestListFilter');
            },
            placeholder: formatMessage((0, $lRvdJ.default).searchButtonPlaceholder),
            shouldFitContainerWidth: true,
            isAutocompleteDisabled: true,
            placeholderAlwaysVisible: true,
            searchIconVisible: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2549fc1cd4ffe721$var$Hr, {
            role: "presentation"
        }), targetsContent);
    }, [
        createPullRequestTargets,
        filteredTargets,
        CreatePullRequestTargets,
        createAnalyticsEvent,
        filterTargetsBySearch,
        formatMessage
    ]);
    const DropDownContent = createPullRequestTargets && createPullRequestTargets.length === 0 && !hasErrors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16reJ.NoEligibleBranches), null) : DropDownWithTargetsContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        id: "create-pull-request-dropdown",
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageType: "transactional",
        zIndex: (0, $dPMMf.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                attributes: {
                    linkListLength: createPullRequestTargets ? createPullRequestTargets.length : 0,
                    filteredListLength: filteredTargets.length
                }
            }, DropDownContent)
    });
};
const $2549fc1cd4ffe721$var$CreatePullRequestDropdown = ({ renderDropdownTrigger: renderDropdownTrigger, createPullRequestTargets: createPullRequestTargets, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2549fc1cd4ffe721$var$CreatePullRequestDropdownInner, {
        renderDropdownTrigger: renderDropdownTrigger,
        createPullRequestTargets: createPullRequestTargets,
        onOpenDropdown: onOpenDropdown,
        hasErrors: hasErrors,
        onAuthErrorClick: onAuthErrorClick
    });
var $2549fc1cd4ffe721$export$2e2bcd8739ae039 = $2549fc1cd4ffe721$var$CreatePullRequestDropdown;
const $2549fc1cd4ffe721$var$dropDownWithTargetsContentWrapperStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2549fc1cd4ffe721$var$SearchFieldWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91feq _19pkidpf _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2549fc1cd4ffe721$var$Hr = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3doudwz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2549fc1cd4ffe721$var$TargetsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _c71l13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9CGHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6fa478636f905bf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c6fa478636f905bf$export$2e2bcd8739ae039 = (haystack, needle)=>{
    if (!needle) return true;
    if (!haystack) return false;
    const haystackLowerCase = haystack.toLocaleLowerCase();
    const needleLowerCase = needle.toLocaleLowerCase();
    return haystackLowerCase.includes(needleLowerCase);
};

});

parcelRegister("dqc6Z", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
function $84caf67c6542222b$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $7jTnu.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $84caf67c6542222b$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    if ($84caf67c6542222b$export$41946885a418e1(textFieldProps) && (0, $7jTnu.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $eJOHy.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $eJOHy.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $eJOHy.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kUoGK", function(module, exports) {

$parcel$export(module.exports, "getSoftwareThemedRoutes", () => $792c5cf1d308dd5d$export$8b0967e3892c7b59);
$parcel$export(module.exports, "useSoftwareProjectTheming", () => $792c5cf1d308dd5d$export$4c26676caf6bb553);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $ln6Iy = parcelRequire("ln6Iy");

var $1302Y = parcelRequire("1302Y");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");

var $i7yNt = parcelRequire("i7yNt");
const $792c5cf1d308dd5d$var$defaultValues = {
    hasSoftwareTheming: false,
    isSoftwareFullTheming: false,
    isSoftwareProject: false
};
const $792c5cf1d308dd5d$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $792c5cf1d308dd5d$export$8838ccecebb0c319 = (0, $kfvK2.createRouterSelector)((state)=>state.match.url);
const $792c5cf1d308dd5d$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    if (!isSoftwareProject) return $792c5cf1d308dd5d$var$defaultValues;
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: isSoftwareProject
    };
    const isM2Enabled = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)();
    const hasSoftwareTheming = isM2Enabled ? isSoftwareProject && (0, $i7yNt.SOFTWARE_THEME_ROUTES_M2).has(currentRoute) && (0, $1302Y.getIsSoftwareThemingM2Enabled)() // Only fire exposure if we are on a themed route
     : isSoftwareProject && (0, $i7yNt.SOFTWARE_THEME_ROUTES).has(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = isM2Enabled ? hasSoftwareTheming && (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES_M2).has(currentRoute) : hasSoftwareTheming && (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES).has(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $792c5cf1d308dd5d$export$8b0967e3892c7b59 = ()=>{
    const allThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.SOFTWARE_THEME_ROUTES_M2) : (0, $i7yNt.SOFTWARE_THEME_ROUTES);
    const fullThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES_M2) : (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES);
    // Enable theming for the shared routes no matter which milestone we are in
    allThemedSoftwareProjectRoutes.add('project-pages');
    allThemedSoftwareProjectRoutes.add('project-components');
    fullThemedSoftwareProjectRoutes.add('project-pages');
    return {
        allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes,
        fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes
    };
};
const $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified = ()=>{
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const currentUrl = $792c5cf1d308dd5d$export$8838ccecebb0c319();
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes, fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes } = $792c5cf1d308dd5d$export$8b0967e3892c7b59();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(currentRoute) && (currentUrl.includes('/jira/software/projects/') || currentUrl.includes('/jira/software/c/projects/') || currentRoute === 'issue');
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    return (0, $eJOHy.useMemo)(()=>{
        if (!isSoftwareProject || !(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
        // temporarily disable theming for calendar
        // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
            hasSoftwareTheming: false,
            isSoftwareFullTheming: false,
            isSoftwareProject: isSoftwareProject
        };
        return {
            hasSoftwareTheming: allThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareFullTheming: fullThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareProject: isSoftwareProject
        };
    }, [
        isSoftwareProject,
        isSoftwareCalendarRoute,
        allThemedSoftwareProjectRoutes,
        currentRoute,
        fullThemedSoftwareProjectRoutes
    ]);
};
const $792c5cf1d308dd5d$export$4c26676caf6bb553 = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified, $792c5cf1d308dd5d$export$52b606e2ebcbaae2);

});
parcelRegister("1302Y", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $02571dfd61e26a65$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $02571dfd61e26a65$export$4fa2eaefe7d59f41);
$parcel$export(module.exports, "getIsSoftwareThemingM2EnabledNoExposure", () => $02571dfd61e26a65$export$8a1bc0266a614408);

var $6zXPf = parcelRequire("6zXPf");

var $epTsa = parcelRequire("epTsa");
const $02571dfd61e26a65$export$a505f57c5130832f = ()=>(0, $6zXPf.getWillShowNav4)() && (0, $epTsa.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $02571dfd61e26a65$export$4fa2eaefe7d59f41 = ()=>$02571dfd61e26a65$export$a505f57c5130832f() && (0, $epTsa.expVal)('jira_theming_milestone_2', 'isEnabled', false);
const $02571dfd61e26a65$export$8a1bc0266a614408 = ()=>{
    if (!$02571dfd61e26a65$export$a505f57c5130832f()) return false;
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_theming_milestone_2');
    return expConfig.get('isEnabled', false);
};

});

parcelRegister("i7yNt", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $686f9881c0e0ac79$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $686f9881c0e0ac79$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $686f9881c0e0ac79$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $686f9881c0e0ac79$export$587ac1561f46cfdc);
// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business
const $686f9881c0e0ac79$export$671a416a5ddfe0ea = new Set([
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $686f9881c0e0ac79$export$891915f6cf3ec6e7 = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
]);
const $686f9881c0e0ac79$export$7a3cdcc7c971b71e = new Set([
    'issue',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $686f9881c0e0ac79$export$1c7e7f18d2f498fe = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog',
    'project-pages',
    'software-form-classic',
    'software-form',
    'software-form-builder-classic',
    'software-form-builder'
]);
const $686f9881c0e0ac79$export$4edc7739f219df7c = new Set([
    ...$686f9881c0e0ac79$export$671a416a5ddfe0ea,
    ...$686f9881c0e0ac79$export$891915f6cf3ec6e7
]);
const $686f9881c0e0ac79$export$587ac1561f46cfdc = new Set([
    ...$686f9881c0e0ac79$export$7a3cdcc7c971b71e,
    ...$686f9881c0e0ac79$export$1c7e7f18d2f498fe
]);

});


parcelRegister("7CY7m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");

var $i0iAU = parcelRequire("i0iAU");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("6t09S", function(module, exports) {

$parcel$export(module.exports, "DevSummaryCreatePullRequestPopupSkeleton", () => $c30205393ae86034$export$2bd52f77e389dbd7);
/* DevSummaryCreatePullRequestPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $j4J4h = parcelRequire("j4J4h");
const $c30205393ae86034$var$containerStyles = null;
const $c30205393ae86034$export$2bd52f77e389dbd7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _4t3i1kei _1v7tn7od _1ieon7od _1vx6n7od _3glbn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j4J4h)))
    }));

});
parcelRegister("j4J4h", function(module, exports) {
module.exports = new URL("dev-summary-create-pull-request-popup.tpl.6a6b4b68.svg", import.meta.url).toString();

});


parcelRegister("fZbyz", function(module, exports) {

$parcel$export(module.exports, "CreatePullRequestAuthenticationRow", () => $94947b48f58e4fe7$export$9fd100251e36a612);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7saMl = parcelRequire("7saMl");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $4FoWm = parcelRequire("4FoWm");
const $94947b48f58e4fe7$export$9fd100251e36a612 = ({ onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94947b48f58e4fe7$var$TargetRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "link",
        action: "viewed",
        actionSubjectId: "createPullRequestAuthenticationMessage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestAuthenticationMessage');
            onClick && onClick();
        },
        shouldTitleWrap: true,
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.button-item"
    }, formatMessage((0, $4FoWm.default).authenticationMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94947b48f58e4fe7$var$LinkFormatted, null, formatMessage((0, $4FoWm.default).openDialogPrompt))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94947b48f58e4fe7$var$TargetRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1kdj _otyru2gc _i1wwu2gc _8ax3pxbi _ake1u2gc _1gqwpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94947b48f58e4fe7$var$LinkFormatted = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4FoWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b0c970535444d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $18b0c970535444d7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    authenticationMessage: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.authentication-message",
        "defaultMessage": "We couldn't load all development information"
    },
    openDialogPrompt: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.open-dialog-prompt",
        "defaultMessage": "Find out more"
    }
});

});


parcelRegister("gSEff", function(module, exports) {

$parcel$export(module.exports, "getTargetDisplayName", () => $10dfa1184a15cc14$export$f9bb2ba84fb7a7cf);
$parcel$export(module.exports, "CreatePullRequestTargetRow", () => $10dfa1184a15cc14$export$46f8f5bb9e981547);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $8rAKL = parcelRequire("8rAKL");

var $f58rc = parcelRequire("f58rc");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cEWKU = parcelRequire("cEWKU");
const $10dfa1184a15cc14$export$f9bb2ba84fb7a7cf = (target)=>`${target.repositoryName}/${target.branchName}`;
const $10dfa1184a15cc14$export$46f8f5bb9e981547 = ({ createPullRequestTarget: createPullRequestTarget })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($10dfa1184a15cc14$var$TargetRow, {
        key: createPullRequestTarget.createPullRequestUrl,
        "data-testid": "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.target-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($10dfa1184a15cc14$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        ), {
            src: createPullRequestTarget.repositoryAvatarUrl,
            appearance: "square",
            size: "xsmall"
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($10dfa1184a15cc14$var$IconContainer, {
            "data-component-selector": "pull-request-icon-after"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
            label: formatMessage((0, $cEWKU.default).shortcutIconLabel),
            LEGACY_size: "small"
        })),
        href: createPullRequestTarget.createPullRequestUrl,
        target: "_blank",
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestLink', {
                scmProvider: createPullRequestTarget.scmProvider
            });
        },
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.link-item"
    }, $10dfa1184a15cc14$export$f9bb2ba84fb7a7cf(createPullRequestTarget))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dfa1184a15cc14$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v5641mbg _tzy4idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dfa1184a15cc14$var$TargetRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1kdj _ep9tidpf _9r1zpxbi _f5gaidpf _hstcpxbi _8udjkb7n _1v8xu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dfa1184a15cc14$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cEWKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8588cb27e772ec33$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8588cb27e772ec33$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    shortcutIconLabel: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.shortcut-icon-label",
        "defaultMessage": "Open link in a new tab"
    }
});

});


parcelRegister("lRvdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cedd4b54c706820$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0cedd4b54c706820$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchButtonPlaceholder: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.search-button-placeholder",
        "defaultMessage": "Select branch to create pull request"
    }
});

});

parcelRegister("16reJ", function(module, exports) {

$parcel$export(module.exports, "NoEligibleBranches", () => $90f47c68ba03d6a4$export$9c262545a50dd8aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $hZAoG = parcelRequire("hZAoG");
const $90f47c68ba03d6a4$export$9c262545a50dd8aa = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($90f47c68ba03d6a4$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "message",
        action: "viewed",
        actionSubjectId: "createPullRequestNoEligibleBranchesFoundMessage"
    }), formatMessage((0, $hZAoG.default).noEligibleBranchesFound));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90f47c68ba03d6a4$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12fnklw _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hZAoG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e24eb62a24adfd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e7e24eb62a24adfd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noEligibleBranchesFound: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.no-eligible-branches.no-eligible-branches-found",
        "defaultMessage": "We can't find any links to create a pull request. You'll need to create a pull request directly in your development tool."
    }
});

});


parcelRegister("gYTjK", function(module, exports) {

$parcel$export(module.exports, "NoResultsFound", () => $41c4b1b6bee694b3$export$c9765147a8dd7e5d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $56yS3 = parcelRequire("56yS3");
const $41c4b1b6bee694b3$export$c9765147a8dd7e5d = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41c4b1b6bee694b3$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "message",
        action: "viewed",
        actionSubjectId: "createPullRequestNoSearchResultsFoundMessage"
    }), formatMessage((0, $56yS3.default).noResultsFound));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41c4b1b6bee694b3$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("56yS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e0f180bc6d3829$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $85e0f180bc6d3829$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noResultsFound: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.no-results-found.no-results-found",
        "defaultMessage": "No matches found"
    }
});

});




$parcel$global.rlb("jjrrg")
//# sourceMappingURL=index-old.d867ef44.js.map
